import React from 'react';
import { CameraIcon, CheckIcon, ImagePlusIcon } from 'lucide-react';
import { mediaLibrary } from '../data/media';
import { useLocale } from '../contexts/LocaleContext';
interface MediaPickerProps {
  value: string | null;
  onChange: (url: string) => void;
}

/** Capture / upload step. The prototype offers a sample library. */
export function MediaPicker({
  value,
  onChange
}: MediaPickerProps) {
  const {
    t,
    tl
  } = useLocale();
  return <div data-id="element-1031" data-mp="ihg2984hdooe">
      <div className="flex gap-1" data-id="element-1032" data-mp="il3u82ua2310">
        <span className="flex min-h-[44px] flex-1 items-center justify-center gap-1 rounded-pill border border-dashed border-deep/25 bg-white/60 px-2 text-[12px] font-medium text-muted" data-id="element-1033" data-mp="dk6avmxj72xx">
          <CameraIcon size={15} aria-hidden="true" data-id="element-1034" data-mp="ni3z4afe4zqj" />
          {t('create.media.capture')}
        </span>
        <span className="flex min-h-[44px] flex-1 items-center justify-center gap-1 rounded-pill border border-dashed border-deep/25 bg-white/60 px-2 text-[12px] font-medium text-muted" data-id="element-1035" data-mp="2u8a6lwv3xe7z">
          <ImagePlusIcon size={15} aria-hidden="true" data-id="element-1036" data-mp="2s7y01kl7h8ku" />
          {t('create.media.upload')}
        </span>
      </div>

      <p className="mt-2 text-[11px] text-muted" data-id="element-1037" data-mp="2w91dy1jp0ujf">{t('create.media.hint')}</p>

      <ul className="bee-rail mt-1 flex gap-1 overflow-x-auto pb-1" data-id="element-1038" data-mp="318meggeihay9">
        {mediaLibrary.map(option => {
        const selected = value === option.url;
        return <li key={option.id} className="shrink-0" data-id="element-1039" data-mp="361fhmzuc0b88">
              <button type="button" onClick={() => onChange(option.url)} aria-pressed={selected} className={`relative block h-[72px] w-[72px] overflow-hidden rounded-[12px] transition-transform duration-150 ease-brand active:scale-[0.98] ${selected ? 'ring-2 ring-gold ring-offset-1 ring-offset-sand' : ''}`} data-id="element-1040" data-mp="3az8q5zj3xhbo">
                <img src={option.url} alt={tl(option.label)} className="h-full w-full object-cover" data-id="element-1041" data-mp="1pmnpmo13l5zg" />
                {selected && <span className="absolute right-1 top-1 grid h-5 w-5 place-items-center rounded-pill bg-gold text-deep" data-id="element-1042" data-mp="2xvd5agoqsmga">
                    <CheckIcon size={12} strokeWidth={3} data-id="element-1043" data-mp="2sycyg3k2jfo4" />
                  </span>}
              </button>
            </li>;
      })}
      </ul>
    </div>;
}